import React from "react";
import ImageList from "./ImageList";
import Image from "../../components/image/Image";
import { Container } from "../../components/container/Container";

const ListWithImage = ({ data, imageSrc }) => {
  const { leftData, rightData } = data;
  return (
    <div className="max-w-7xl mx-auto w-full px-4 md:px-6">
      <Container className="flex flex-col md:flex-row items-center justify-center gap-6 text-center md:text-left">
        {/* Left List */}
        <div className="w-full md:w-1/3 flex justify-center">
          <ImageList items={leftData} />
        </div>

        {/* Center Image */}
        <div className="w-full md:w-1/3 flex justify-center">
          <Image
            src={imageSrc.src}
            alt={imageSrc.alt}
            className="w-full max-w-xs object-contain"
          />
        </div>

        {/* Right List */}
        <div className="w-full md:w-1/3 flex justify-center  ">
          <ImageList items={rightData} />
        </div>
      </Container>
    </div>
  );
};

export default ListWithImage;
